export default __webpack_public_path__ + "static/media/icon_react.809fed23.png";